export default "__VITE_ASSET__QfU6oviU__"